import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

/**
 * Master v5 Prompt 30C Phase 2 — `checklist` input type editor. Value is
 * a structured array `[{id, label, checked}]` with label and checked
 * state kept as separate fields, per spec.
 */
export function ChecklistInputEditor({ value, onChange, disabled, testId }) {
  const items = value || [];

  const update = (next) => onChange(next);
  const setLabel = (id, label) => update(items.map((it) => (it.id === id ? { ...it, label } : it)));
  const toggle = (id) => update(items.map((it) => (it.id === id ? { ...it, checked: !it.checked } : it)));
  const removeItem = (id) => update(items.filter((it) => it.id !== id));
  const addItem = () => update([...items, { id: `item_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`, label: "", checked: false }]);

  return (
    <div className="space-y-2" data-testid={testId || "checklist-input-editor"}>
      {items.map((item, i) => (
        <div key={item.id} className="flex items-center gap-2" data-testid={`checklist-input-item-${i}`}>
          <Checkbox checked={!!item.checked} disabled={disabled} onCheckedChange={() => toggle(item.id)} data-testid={`checklist-input-item-${i}-checkbox`} />
          <Input value={item.label} disabled={disabled} onChange={(e) => setLabel(item.id, e.target.value)} placeholder={`Checklist item ${i + 1}`} data-testid={`checklist-input-item-${i}-label`} />
          <Button type="button" variant="ghost" size="sm" disabled={disabled} onClick={() => removeItem(item.id)} data-testid={`checklist-input-item-${i}-remove`}>
            <Trash2 className="h-4 w-4 text-muted-foreground" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" disabled={disabled} onClick={addItem} data-testid="checklist-input-add-item-btn">
        <Plus className="h-3.5 w-3.5 mr-1" /> Add item
      </Button>
    </div>
  );
}
